import * as Icons from "lucide-react";
import { BadgeCheck } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { VERIFICATION_STANDARDS } from "@/data/content";

export const VerificationStandards = () => {
  return (
    <section id="standards" data-testid="standards-section" className="relative py-24 sm:py-32 bg-[#F8F9FB] border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>Verification Standards</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-tight text-slate-900">
              Six standards behind every verified badge.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Each dimension is independently assessed and scored, then continuously re-reviewed to keep every profile trustworthy.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {VERIFICATION_STANDARDS.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.ShieldCheck;
            return (
              <Reveal key={s.title} delay={i * 0.05}>
                <div data-testid={`standard-card-${i}`} className="group h-full bg-white border border-slate-200/80 rounded-2xl sm:rounded-3xl p-6 sm:p-7 transition-all duration-300 hover:shadow-[0_20px_40px_rgba(15,23,42,0.08)] hover:-translate-y-1 hover:border-blue-200">
                  <div className="flex items-start justify-between">
                    <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-blue-50 text-blue-600 border border-blue-100 transition-colors group-hover:bg-blue-600 group-hover:text-white"><Icon className="w-5 h-5" /></span>
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold border border-emerald-100"><BadgeCheck className="w-3.5 h-3.5" />{s.status}</span>
                  </div>
                  <h3 className="mt-5 text-lg font-semibold text-slate-900">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.description}</p>
                  <div className="mt-5">
                    <div className="flex items-center justify-between text-xs mb-1.5">
                      <span className="text-slate-500 font-medium">Confidence Score</span>
                      <span className="font-mono font-semibold text-slate-900">{s.confidence}%</span>
                    </div>
                    <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
                      <div className="h-full rounded-full bg-gradient-to-r from-blue-500 to-emerald-500" style={{ width: `${s.confidence}%` }} />
                    </div>
                  </div>
                  <div className="mt-5 pt-4 border-t border-slate-100 grid grid-cols-2 gap-3 text-xs">
                    <div><div className="text-slate-400">Last Review</div><div className="mt-0.5 font-medium text-slate-700">{s.lastReview}</div></div>
                    <div><div className="text-slate-400">Verified On</div><div className="mt-0.5 font-medium text-slate-700">{s.verifiedOn}</div></div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VerificationStandards;
